import { useMemo } from 'react';
import useRefresh from './useRefresh';

export default function useRefreshTimestamp(timestamp: string | number | Date): void {
  const date = useMemo(() => new Date(timestamp), [timestamp]);
  const now = Date.now();
  let time: number | undefined;
  if (now - date.getTime() < 60 * 60 * 1000) {
    time = 60 * 1000;
  }
  useRefresh(time);
}
